/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_not_found_title = /** @type {(inputs: {}) => string} */ () => {
	return `Página no encontrada`
};

const en_not_found_title = /** @type {(inputs: {}) => string} */ () => {
	return `Page not found`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const not_found_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.not_found_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("not_found_title", locale)
	if (locale === "es") return es_not_found_title(inputs)
	return en_not_found_title(inputs)
};
export { not_found_title as "not_found.title" }